import React from "react";

import * as Styles from "./styles";

import P from "prop-types";

export function TabBar({ setStateFunc, tabIndex }) {
  function handleOnClick(number) {
    setStateFunc(number);
  }
  return (
    <Styles.Container>
      <Styles.TabBar>
        <Styles.TabToggle
          selected={tabIndex === 1}
          onClick={() => handleOnClick(1)}
        >
          Casos de covid-19
        </Styles.TabToggle>

        <Styles.TabToggle
          selected={tabIndex === 2}
          onClick={() => handleOnClick(2)}
        >
          Sentimentos e satisfação
        </Styles.TabToggle>
        
        <Styles.TabToggle
          selected={tabIndex === 3}
          onClick={() => handleOnClick(3)}
        >
          Estudo I
        </Styles.TabToggle>
        
      </Styles.TabBar>
    </Styles.Container>
  );
}

TabBar.propTypes = {
  setStateFunc: P.func.isRequired,
};
